<template>
    <button class="btn btn-back" @click.prevent="$router.go(-1)">Back</button>
</template>